import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import ModalPreview from "components/Common/ModalPreview";
import CollapseFilter from "components/Common/CollapseFilter";
import { getListStaff, putStaff } from "store/staff/thunk";
import StaffForm from "./StaffForm";
import { Link } from "react-router-dom";
import TooltipCustom from "components/Common/TooltipCustom";
import staffApi from "api/staffApi";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { COLOR_BAR_DETAIL_REVIEW_STATUS, COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS, COLOR_BAR_DETAIL_STAFF_POSITION, COLOR_TYPE_BARTENDER, LIST_OPTION_BAR_DETAIL_REVIEW_STATUS, LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS, LIST_OPTION_BAR_DETAIL_STAFF_POSITION, LIST_OPTION_GENDER, LIST_OPTION_TYPE_BARTENDER } from "helpers/constans";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import moment from "moment";
import avatar1 from "../../../../assets/images/users/ic_defaul_avatar2.png";
import hashTagApi from "api/hashTagApi";

registerLocale("en", en);
registerLocale("ko", ko);

export interface ISearch {
  page: number;
  limit: number;
  keyword: string;
}

const DEFAULT_DATA_SEARCH = {
  page: 1,
  limit: 30,
  keyword: "",
};

export interface IProps {
  barID?: any
}

const StaffList = ({
  barID,
}: IProps) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [queryStaff, setQueryStaff] = useState<ISearch | any>(DEFAULT_DATA_SEARCH)

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [linkImage, setLinkImage] = useState<string>("");
  const [lstStaffs, setLstStaffs] = useState<any>([]);
  const [listHashtag, setListHashTag] = useState<any>([]);

  const [nameSearch, setNameSearch] = useState<string>("");
  const [phoneSearch, setPhoneSearch] = useState<string>("");
  const [bioSearch, setBioSearch] = useState<string>("");
  const [hashTagSearch, setHashTagSearch] = useState<string>("");
  const [typeSearch, setTypeSearch] = useState<string>("");
  const [genderSearch, setGenderSearch] = useState<string>("");
  const [statusSearch, setStatusSearch] = useState<string>("");
  const [approvedStatusSearch, setApprovedStatusSearch] = useState<any>("");
  const [dateSearch, setDateSearch] = useState<any[]>([null, null]);
  const [startDate, endDate] = dateSearch;

  const loadTableData = async (queryData?: ISearch) => {
    setIsLoading(true);
    try {
      // const resDetail: any = await getBarDetail(barID);
      const resStaffByBarId: any = await getListStaff({
        ...queryData,
        bar_id: barID
      });

      if (resStaffByBarId?.data) {
        setLstStaffs(resStaffByBarId?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error)
    }
  }

  const searchData = () => {
    loadTableData(queryStaff);
  };

  const resetData = () => {
    setQueryStaff(DEFAULT_DATA_SEARCH);
    setNameSearch("");
    setPhoneSearch("");
    setBioSearch("");
    setHashTagSearch("");
    setTypeSearch("");
    setGenderSearch("");
    setStatusSearch("");
    setApprovedStatusSearch("");
    setDateSearch([null, null]);
    loadTableData(DEFAULT_DATA_SEARCH);
  };

  const handleChangeKeyword = (key: string, value: string) => {
    setQueryStaff({
      ...queryStaff,
      [key]: value
    })
  }

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await putStaff(
        item?.id,
        { status: item?.is_active === false ? 0 : 1 }
      );
      if (response?.code === 200) {
        loadTableData(queryStaff);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        Cell: ({ ...props }) => {
          return (
            <div>
              {lstStaffs?.meta?.total -
                ((queryStaff?.page - 1) * queryStaff?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 80,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                checked={!!cell?.value}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({ id: item?.id, is_active: !!value });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Type"),
        accessor: "staff_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_TYPE_BARTENDER[status] || "secondary"
                  }`}
              >
                {t(LIST_OPTION_TYPE_BARTENDER?.find(
                  (item: any) => String(item?.value) === String(status)
                )?.label || '')
                }
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Approved Status"),
        accessor: "approved_status",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS[status] || "secondary"
                  }`}
              >
                {t(LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS?.find(
                  (item: any) => String(item?.value) === String(status)
                )?.label || '')
                }
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Avatar"),
        accessor: "image",
        thClass: "text-center",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {

          return (
            <>
              <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                <div
                  style={{ width: "45px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => setLinkImage((prev) => cell?.value)}
                >
                  <img
                    src={cell?.value || avatar1}
                    className="rounded-circle avatar-sm"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div>
              </div>
            </>
          )
        }
      },
      {
        Header: t("Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thWidth: 130,
        Cell: (cell: any) => {
          const nickName = cell?.row?.original?.name;

          return (
            <>
              <div className="cursor-pointer">
                {nickName}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Position"),
        accessor: "position",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-center",
        Cell: (cell: any) => {
          const position = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_BAR_DETAIL_STAFF_POSITION[position] || "secondary"}`}
              >
                {t(LIST_OPTION_BAR_DETAIL_STAFF_POSITION?.find(
                  (item: any) => String(item?.value) === String(position)
                )?.label || '')
                }
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Gender"),
        accessor: "gender",
        filterable: true,
        sortable: false,
        thClass: "text-center",
        thWidth: 130,
        Cell: (cell: any) => {
          const gender = cell?.row?.original?.gender;

          return (
            <>
              <div className="text-center">
                <span
                >
                  {t(LIST_OPTION_GENDER?.find(
                    (item: any) => String(item?.value) === String(gender)
                  )?.label || '')
                  }
                </span>
              </div>
            </>
          );
        },
      },
      // {
      //   Header: t("Phone Number"),
      //   accessor: "phone",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 130,
      //   Cell: (cell: any) => {
      //     const phone = cell?.value;

      //     return (
      //       <>
      //         <div className="cursor-pointer">
      //           {phone}
      //         </div>
      //       </>
      //     );
      //   },
      // },
      {
        Header: t("Hashtags"),
        accessor: "hashtags",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 300,
        Cell: (cell: any) => {
          const allKeyword = cell?.value;

          return (
            allKeyword?.length > 0 && (
              <div>
                <div className="d-flex gap-1" style={{ flexWrap: 'wrap', minWidth: 280 }}>
                  {allKeyword?.map((item: any, index: number) => {
                    let tagName: string = "";
                    let bgColor: string = item?.normal_background_color;
                    let textColor: string = item?.normal_text_color;

                    tagName += `${item?.content ? `#${item?.content}` : ""
                      }`;

                    return (
                      <span
                        dangerouslySetInnerHTML={{ __html: tagName }}
                        key={index}
                        className="tag-style"
                        style={({ backgroundColor: bgColor, borderColor: bgColor, color: textColor })}
                      />
                    );
                  })}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Start Time"),
        accessor: "started_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${barID}`}
              >
                <li className="list-inline-item" id={`update-md-${barID}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToEdit(item);
                      setIsOpen(true);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${barID}`}
              >
                <li className="list-inline-item" id={`delete-md-${barID}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstStaffs?.meta?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQueryStaff({ ...queryStaff, page: page + 1 });
    loadTableData({ ...queryStaff, page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };
  // Begin::Delete

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
    const [startDate, endDate] = values;
    if (startDate || endDate) {
      setQueryStaff({
        ...queryStaff,
        start_date: startDate
          ? formatDateStringToUTC(moment(new Date(startDate)).startOf("day").format("Y-MM-DD HH:mm:ss"))
          : "",
        end_date: endDate ? formatDateStringToUTC(moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")) : "",
      })
    } else {
      setQueryStaff({
        ...queryStaff,
        start_date: "",
        end_date: "",
      })
    }
  };

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await staffApi?.deleteStaff(id);

      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const triggerRefresh = () => {
    setItemToEdit(null);
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    if (barID) {
      loadTableData()
    }
  }, [])

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [hashtags]: any = await Promise.all([
          hashTagApi.getHashTags(),
        ]);
        setListHashTag((_prev: any) => hashtags?.data?.items || []);

      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  // End::Delete
  useEffect(() => {
    document.title = `${t("Staff")} - ${t("Store List")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="mt-3">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-2 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstStaffs?.meta?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total System")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstStaffs?.meta?.summary?.total_system || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Bartender User")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstStaffs?.meta?.summary?.total_bartender_user || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Approved")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstStaffs?.meta?.summary?.approved_count || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Waiting")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstStaffs?.meta?.summary?.waiting_count || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>

                    <div className="col-sm-auto">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true)
                          setItemToEdit(null)
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Bartender")}
                      </button>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={LIST_OPTION_TYPE_BARTENDER || []}
                            placeholder={`${t("Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={typeSearch}
                            onChangeSelect={(e: any) => {
                              handleChangeKeyword("staff_type", e?.value);
                              setTypeSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_TYPE_BARTENDER}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Gender")} isShow={true}>
                          <DropdownOptionNew
                            name="gender"
                            dataList={LIST_OPTION_GENDER || []}
                            placeholder={`${t("Gender")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={genderSearch}
                            onChangeSelect={(e: any) => {
                              handleChangeKeyword("gender", e?.value);
                              setGenderSearch(e?.value);
                            }}
                            // onChangeSelect={(e: any) => setGenderSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) => {
                              handleChangeKeyword("status", e?.value);
                              setStatusSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Approved Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS || []}
                            placeholder={`${t("Approved Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={approvedStatusSearch}
                            onChangeSelect={(e: any) => {
                              handleChangeKeyword("approved_status", e?.value);
                              setApprovedStatusSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3"
                      >
                        <LabelWrapper
                          label={t("Name")}
                          isShow={!!nameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={nameSearch}
                            onChange={(e) => {
                              setNameSearch(e?.target?.value);
                              handleChangeKeyword("name", e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3"
                      >
                        <LabelWrapper
                          label={t("Phone Number")}
                          isShow={!!phoneSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Phone Number")}...`}
                            value={phoneSearch}
                            onChange={(e) => {
                              setPhoneSearch(e?.target?.value);
                              handleChangeKeyword("phone", e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3"
                      >
                        <LabelWrapper
                          label={t("Bio")}
                          isShow={!!bioSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Bio")}...`}
                            value={bioSearch}
                            onChange={(e) => {
                              setBioSearch(e?.target?.value);
                              handleChangeKeyword("bio", e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3"
                      >
                        <LabelWrapper
                          label={t("Hashtag")}
                          isShow={!!hashTagSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Hashtag")}...`}
                            value={hashTagSearch}
                            onChange={(e) => {
                              setHashTagSearch(e?.target?.value);
                              handleChangeKeyword("hashtag", e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-bar-bartender-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={lstStaffs?.list?.length ? lstStaffs?.list : []}
                      customPageSize={queryStaff.limit}
                      customPageIndex={queryStaff.page - 1}
                      totalRecords={lstStaffs?.list?.length}
                      customPageCount={Math.ceil(
                        Number(lstStaffs?.list?.length) / Number(queryStaff.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      // sorting={{
                      //   sort_by: queryStaff.sort_by,
                      //   order_by: queryStaff.order_by,
                      // }}
                      // handleChangeSorting={handleChangeSorting}
                      isLoading={isLoading}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          isOpen={!!itemToEdit?.id || isOpen}
          centered={true}
          size="xl"
          scrollable={false}
        >
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?.id
                ? t("Button Update Bartender")
                : t("Button Create Bartender")}
            </>{" "}
            <>
              {itemToEdit?.title &&
                (" - " +
                  (itemToEdit?.name || "") ||
                  "")}
            </>
          </ModalHeader>
          <ModalBody>
            <StaffForm
              id={String(itemToEdit?.id || "")}
              triggerRefresh={triggerRefresh}
              setLinkImage={setLinkImage}
              rowSelected={itemToEdit}
              barId={barID}
              listHashtag={listHashtag}
            />
          </ModalBody>
        </Modal>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Bartender")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default StaffList;
